define(function (require) {
  "use strict";

  var Marionette = require("marionette");
  var _ = require("underscore");
  var tplHeader = require("text!./index.tpl").default;
  var modal = require("behaviors/modal");
  var popover = require("behaviors/popover");
  var HeaderRight = require("views/header/index");
  var Backbone = require("backbone");
  var $ = require("jquery");
  var Model = Backbone.Model.extend();
  var AppConfig = require("config/application");
  var BalancePopover = require("popovers/balance/view");
  var NumFormat = require("system/libs/num_format");

  const React = require("react");
  const ReactDOM = require("react-dom");
  const Projects = require("src/components/Projects/Projects.tsx").default;

  var animationSpeed = 400;

  return Marionette.LayoutView.extend({
    _view: [],

    template: tplHeader,
    className: "navbar-inner",

    leftSidebar: $("#left-sidebar"),
    rightSidebar: $("#right-sidebar"),
    leftSidebarOpen: false,
    rightSidebarOpen: false,

    checkStatusTimout: 30000,

    regions: {
      regionHeaderRight: "#js-region-header-right",
    },

    ui: {
      collapseSidebar: "#layout-condensed-toggle",
      btnCaller: ".js-caller",
      btnProjects: "#js-header-project-name-region",
      btnTasks: ".js-btn-tasks",
      btnNotes: ".js-btn-notes",
      btnAlerts: ".js-btn-alerts",
      btnCalls: ".js-btn-calls",
      btnMsgs: ".js-btn-msgs",
      btnNotice: ".js-btn-notice",
      btnNotepad: ".js-btn-notes",
      overlay: ".js-header-overlay",
      btnBalance: ".js-balance",
      btnDelDemo: ".js-delete-demo",
      switch: ".js-switch-allowcalls",
      balanceValue: ".js-balance-value",
    },

    events: {
      "click @ui.collapseSidebar": "collapseSidebar",
      // 'click @ui.btnChat'    : 'toggleChat',
      "click @ui.btnCaller": "toggleCaller",
      "click @ui.btnProjects": "toggleProjects",
      "click @ui.btnTasks": "toggleTasks",
      "click @ui.btnNotes": "toggleNotes",
      "click @ui.btnAlerts": "toggleAlerts",
      "click @ui.btnCalls": "toggleCalls",
      "click @ui.btnMsgs": "clickMsgs",
      "click @ui.btnNotice": "toggleNotice",
      "click @ui.btnNotepad": "toggleNotepad",
      "click @ui.btnBalance": "checkTariff",
      "click @ui.btnDelDemo": "deleteDemo",
      "change @ui.switch": "switchAllowCalls",
    },

    behaviors: {
      modal: {
        behaviorClass: modal,
      },
      popover: {
        behaviorClass: popover,
      },
    },

    initialize: function () {
      var that = this;

      app.Sidebars.Caller = require("parts/caller");
      app.Sidebars.Projects = require("parts/projects");
      app.Sidebars.Tasks = require("parts/tasks");
      app.Sidebars.Alerts = require("parts/alerts");
      if (app.Models.Account.get("telephony_version") != 2) {
        app.Sidebars.Calls = require("parts/calls/index");
      } else {
        app.Sidebars.Calls = require("modules/caller/index");
      }
      app.Sidebars.Notice = require("parts/notice");
      app.Sidebars.Notepad = require("parts/notepad");

      app.Collections.ChatMessagesCount = new Backbone.Collection();

      this.model = new Model();
      this.model.set(app.Models.curProject.toJSON());
      this.model.set(app.Models.Account.toJSON());
      this.model.set({ avatar: app.Models.User.get("avatar") });
      this.model.set(
        "showUser",
        app.Models.Account.get("telephony_version") != 2
      );

      this.isFirefoxOnWin =
        navigator.userAgent.toLowerCase().indexOf("firefox") > -1 &&
        navigator.platform.indexOf("Win") > -1;
      if (!app.Models.Account.get("tariff_id")) {
        this.checkStatusTimout = 60000;
      }
      this.listenTo(
        app.Models.Account,
        "change:balance",
        function (model, value) {
          if (!app.Models.Account.get("tariff_id") && value > 0) {
            //location.reload();
          } else {
            that.model.set("balance", value);
            that.ui.balanceValue.html(`<span class="price">${NumFormat(value)}</span><i class="fa fa-rub"></i>`);
          }
        }
      );

      this.listenTo(app.Vents, "page:start:save", this.showOverlay);
      this.listenTo(app.Vents, "page:end:save", this.hideOverlay);
      this.listenTo(app.Vents, "table:sidebarCollapsed", this.onLeadsSidebarCollapsed);
      this.listenTo(app.Models.User, "change:allow_calls", this.switchUiAllowCalls);
    },

    showOverlay: function () {
      this.ui.overlay.show();
    },

    hideOverlay: function () {
      this.ui.overlay.hide();
    },

    deleteDemo: function () {
      var that = this;
      app.confirm_delete({
        title_text: "демо-данные?",
        body_text:
          "Изменения вернуть невозможно. Демо-данные будут потеряны навсегда для всех пользователей.",
        confirm_text: "Что бы удалить демо-данные, введите",
        success: function () {
          Backbone.ajax({
            url: `${AppConfig.host}/rest/sites/${app.curProject.id}/delete_demo_data`,
            type: "POST",
            success: function () {
              // var project = app.Collections.Projects.get(app.curProject.id);
              app.Models.curProject.set("demo_data", 0);
              app.message.success("Демо-данные удалены!");
            },
          });
        },
      });
    },

    checkTariff: function (event) {
      if (!app.Models.Account.get("tariff_id")) {
        app.Router.navigate("tariffs", true);
      } else {
        this.triggerMethod("showPopover", {
          view: BalancePopover,
          target: event.target,
        });
      }
    },

    onBeforeRender: function () {
      const product = app.Models.User.get('product');

      this.model = new Model();
      this.model.set(app.Models.curProject.toJSON());
      this.model.set(app.Models.Account.toJSON());
      this.model.set(
        "showUser",
        app.Models.Account.get("telephony_version") != 2
      );

      this.model.set({
        avatar: app.Models.User.get("avatar"),
        smallLogo: app.States.smallLogo,
        bigLogo: app.States.bigLogo,
        accessBalance: app.Models.User.get("balance") && (!product || product.options.balance),
        allowCalls: app.Models.User.get("allow_calls"),
        acceptCalls: !product || product.options.accept_calls,
        showProjectSelect: !product || product.options.project,
      });
    },

    onRender: function () {
      // const project = app.Collections.Projects.get((app.curProject && app.curProject.id) || {});
      const product = app.Models.User.get('product');

      app.Rivets.bind(this.el, {
        model: this.model,
        project: app.Models.curProject,
        showCleanDemo: app.Models.curProject.get('demo_data') && (!product || product.options.demo_clean_button),
        // tariff: app.Models.Tariff,
      });

      this.hideLeftSidebar();
      this.regionHeaderRight.show(new HeaderRight({ model: this.model }));
      // this.ui.switch[0].checked = app.Models.User.get("allow_calls");
    },

    // onRenderHandler: function () {
    //   this.hideLeftSidebar();
    //   this.regionHeaderRight.show(new HeaderRight({ model: this.model }));
    //   this.ui.switch[0].checked = app.Models.User.get("allow_calls");
    // },

    showLeftSidebar: function (hash) {
      this.leftSidebar
        .removeClass("hide slideOutLeft")
        .addClass("animated-" + animationSpeed + " slideInLeft open");
      this.leftSidebarOpen = hash;
    },

    hideLeftSidebar: function () {
      this.leftSidebar
        .removeClass("slideInLeft open")
        .addClass("animated-" + animationSpeed + " slideOutLeft");
      this.leftSidebarOpen = false;
    },

    getFilteredProjects: function () {
      var projects = [];
      var currentUserId = app.Models.User.get("id");
      var currentUserType = app.Models.User.get("profile_type");
      app.Collections.Projects.each(function (projectModel) {
        var users = projectModel.get("users");
        _.each(users, function (user) {
          if (user.id == currentUserId && user.type == currentUserType) {
            projects.push(projectModel.toJSON());
          }
        });
      });

      // Temp solution no new model yet
      for (let i = 0; i < projects.length - 1; i++) {
        projects[i].id === projects[i + 1].id && projects.splice(i, 1);
      }

      return projects;
    },

    showInLeftSidebar: function (hash) {
      if (this.leftSidebarOpen === false) {
        app.Collections.Projects.fetch()
          .then(() => {
            const onBeforeChangeProject = () => {
              app.Vents.trigger("app:beforeChangeProject");
            };
            const onSelectProject = (id) => {
              app.Vents.trigger("app:selectProject", id);
            };
            const onShowModal = (event) => {
              app.Vents.trigger("modal:showModal", event);
            };
            const onClickProject = () => {
              this.hideLeftSidebar();
            }
          const renderProjects = () => {
            const collection = this.getFilteredProjects();
              ReactDOM.render(
                React.createElement(Projects, {
                  collectionOfProjects: collection,
                  onBeforeChangeProject,
                  onSelectProject,
                  onShowModal,
                  onClickProject,
                }),
                this.leftSidebar[0]
              );
          }
          renderProjects();
          this.showLeftSidebar(hash);
          this.listenTo(app.Collections.Projects, 'add remove', () => {
            renderProjects();
            this.listenTo(app.Collections.Projects, 'add remove', () => {
              renderProjects();
            })
          })
        })
      } else {
        this.hideLeftSidebar();
      }
    },

    showRightSidebar: function (hash) {
      this.rightSidebar
        .removeClass("slideOutRight hide")
        .addClass("animated-" + animationSpeed + " slideInRight");
      this.rightSidebarOpen = hash;
    },

    hideRightSidebar: function () {
      this.rightSidebar
        .removeClass("slideInRight")
        .addClass("animated-" + animationSpeed + " slideOutRight");
      this.rightSidebarOpen = false;
    },

    showInRightSidebar: function (view, hash) {
      if (view.isDestroyed && view === app.Temp.sidebar) {
        view = this.initSidebarNotepad();
      }
      // если закрыт левый сайдбар
      if (this.rightSidebarOpen === false) {
        app.regionRightSidebar.show(view);
        this.showRightSidebar(hash);
      } else {
        // если не пытаемся открыть одну и ту же вьюху 2ой раз
        if (this.rightSidebarOpen != hash) {
          this.hideRightSidebar();
          setTimeout(
            function () {
              app.regionRightSidebar.show(view);
              this.showRightSidebar(hash);
            }.bind(this),
            animationSpeed
          );
        } else {
          this.hideRightSidebar();
          view.destroy();
        }
      }
    },

    hideAllSidebar: function () {
      this.hideLeftSidebar();
      this.hideRightSidebar();
    },

    /*
     * Метод выводит окно с чатом
     */
    toggleChat: function (e) {
      e.preventDefault();
      if (app.States.isChatOpen) {
        app.States.isChatOpen = false;
      } else {
        app.States.isChatOpen = true;
      }
      app.States.isBigChatOpen = false;
      $("body").removeClass("mini big-chat");
      this.showInRightSidebar(new app.Sidebars.Chat(), "chat");
    },

    /*
     * Метод выводит правый блок с задачами
     */
    toggleTasks: function (e) {
      e.preventDefault();
      window.location = "#calendar";
    },

    /*
     * Метод выводит правый блок с оповещениями
     */
    // toggleAlerts: function (e) {
    //   e.preventDefault();
    //   this.showInRightSidebar(new app.Sidebars.Alerts(), "alerts");
    // },

    toggleNotepad: function (e) {
      e.preventDefault();
      if (!app.Temp.sidebar) this.initSidebarNotepad();

      this.showInRightSidebar(app.Temp.sidebar, "notepad");
      $("#right-sidebar").children("div").addClass("notepadBackground");
    },

    initSidebarNotepad: function () {
      app.Temp.sidebar = new app.Sidebars.Notepad();
      return app.Temp.sidebar;
    },

    clickMsgs: function (e) {
      e.preventDefault();
      Backbone.history.navigate(
        encodeURI(
          '#leads?filter={"unseen_chats": [{"id": "1", "text": "Да", "hidden": "unseen_chats"}],"lead_owner":[{"id": "=", "text": "=", "hidden": "lead_owner"},{"id": "' +
            (app.Models.User.get("profile_type") == 0
              ? "main"
              : app.Models.User.id) +
            '", "text": "' +
            app.Models.User.get("name") +
            '", "hidden": "lead_owner"}]}'
        ),
        true
      );
    },

    toggleCalls: function (e) {
      e.preventDefault();
      this.showInRightSidebar(new app.Sidebars.Calls(), "calls");
    },

    // toggleNotice: function (e) {
    //   e.preventDefault();
    //   this.showInRightSidebar(new app.Sidebars.Notice(), "notice");
    // },

    toggleProjects: function (e) {
      e.preventDefault();
      app.States.projectsListSeen = true;
      this.showInLeftSidebar("projects");
    },

    toggleCaller: function (e) {
      e.preventDefault();
      if (
        this._view["caller"] == undefined ||
        this._view["caller"].isDestroyed
      ) {
        this._view["caller"] = new app.Sidebars.Caller();
      }
      this.showInLeftSidebar(this._view["caller"], "caller");
      //this.showInLeftSidebar(new app.Sidebars.Caller(), 'caller');
    },

    toggleSidebar: function (e) {
      if ($("body").hasClass("sidebar-opened")) {
        $("body").removeClass("sidebar-opened");

        // if (typeof app.datatable.el != "undefined") {
        //   if (!$.isEmptyObject(app.datatable.el)) {
        //     app.datatable.el.jqxGrid("refresh");
        //   }
        // }

        //if (e) $.cookie('LPT_collapse_menu', false);
      } else {
        $("body").addClass("sidebar-opened");

        //if (e) $.cookie('LPT_collapse_menu', true);

        // if (typeof app.datatable.el != "undefined") {
        //   if (!$.isEmptyObject(app.datatable.el)) {
        //     app.datatable.el.jqxGrid("refresh");
        //   }
        // }

        // var elem = $("#sidebar-menu ul");
        // elem
        //   .children("li.open")
        //   .children("a")
        //   .children(".arrow")
        //   .removeClass("open");
        // elem
        //   .children("li.open")
        //   .children("a")
        //   .children(".arrow")
        //   .removeClass("active");
        // elem.children("li.open").children(".sub-menu").slideUp(200);
        // elem.children("li").removeClass("open");
      }

      // this.resizeInsideTables();
    },

    collapseSidebar: function (e) {
      if (e) e.preventDefault();

      this.toggleSidebar(e);
      app.Vents.trigger("sidebar:collapsed");
    },

    onLeadsSidebarCollapsed: function (e) {
      //if(!$('body').hasClass('mini')){
      //    this.toggleSidebar(e);
      //}
    },

    onShow: function () {
      var isMobile =
        /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino|android|ipad|playbook|silk/i.test(
          navigator.userAgent || navigator.vendor || window.opera
        ) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
          (navigator.userAgent || navigator.vendor || window.opera).substr(0, 4)
        );

      //if ($.cookie('LPT_collapse_menu') == 'true' && !$('body').hasClass('mini')) {
      //    _.defer(this.collapseSidebar.bind(this));
      //}
      $(window).on('hashchange', this.hideLeftSidebar.bind(this));
    },

    resizeInsideTables: function () {
      if (typeof app.curPage !== "undefined") {
        if (typeof app.curPage.setDefaultColumnsSize !== "undefined") {
          app.curPage.setDefaultColumnsSize();
        }
      }
    },

    changeAllowCalls: function () {
      var that = this;
      var allow_calls = that.ui.switch[0].checked;
      var attrs = {
        allow_calls: allow_calls,
        id: app.Models.User.get("id"),
        profile_type: app.Models.User.get("profile_type"),
      };

      Backbone.ajax({
        url: AppConfig.host + "/rest/staff/allow_calls",
        type: "PUT",
        dataType: "json",
        data: JSON.stringify(attrs),
        success: that.successSave.bind(that),
        error: that.errorSave.bind(that),
      });
    },

    successSave: function (response) {
      if (this.isDestroyed) {
        return;
      }
      if (response.status == 1) {
        app.message.success("Сохранено", undefined, undefined, { id: 'saved' });
      } else {
        this.resetAllowCalls();
      }
    },

    errorSave: function (xhr) {
      var json = jQuery.parseJSON(xhr.responseText);
      if (this.isDestroyed) {
        return;
      }
      app.message.error(json.message || "Ошибка");
      this.resetAllowCalls();
    },

    switchUiAllowCalls: function () {
      this.ui.switch[0].checked = app.Models.User.get("allow_calls");
    },

    switchAllowCalls: function () {
      app.Models.User.set({ allow_calls: this.ui.switch[0].checked });
      this.changeAllowCalls();
    },

    resetAllowCalls: function () {
      app.Models.User.set(
        { allow_calls: app.Models.User.previous("allow_calls") },
        { silent: true }
      );
      this.ui.switch[0].checked = app.Models.User.get("allow_calls");
    },
  });
});
